import i18n from '@/utils/i18n';
import React from 'react';
import { CreditRequestInvoiceDetailsContent } from '@/components/credit-request/credit-request-invoice-details-content';
import { PageContainer } from '@/components/page-container';
import { RouteProp } from '@react-navigation/native';
import {
  selectTotalPriceInMicros,
  useCreditRequestInvoiceStoreApi,
} from '@/stores/credit-request-invoice-store';
import { SHORT_PAY_CREDIT_REQUEST_ROUTES } from '@/navigators/routes';
import { ShortPayCreditRequestStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  navigation: StackNavigationProp<
    ShortPayCreditRequestStackParams,
    SHORT_PAY_CREDIT_REQUEST_ROUTES.Details
  >;
  route: RouteProp<
    ShortPayCreditRequestStackParams,
    SHORT_PAY_CREDIT_REQUEST_ROUTES.Details
  >;
}

export const ShortPayCreditRequestDetailsScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const { onComplete, orderInvoiceUUID, subtotalInMicros, title } =
    route.params;
  const creditRequestStoreApi = useCreditRequestInvoiceStoreApi();
  const { showErrorToast } = useToasts();

  const handleSubmit = () => {
    const state = creditRequestStoreApi.getState();
    const creditTotalInMicros = selectTotalPriceInMicros(state);
    const paymentAmountInMicros = subtotalInMicros - creditTotalInMicros;
    if (paymentAmountInMicros <= 0) {
      showErrorToast(i18n.t('partial_payment.error.zero_payment'));
      return;
    }
    navigation.getParent()?.goBack();
    onComplete(paymentAmountInMicros, state.batchItems);
  };

  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        responsive: true,
        showBackButton: true,
        showShadow: false,
        title,
      }}
    >
      <CreditRequestInvoiceDetailsContent
        onEmpty={() => navigation.goBack()}
        onSubmit={handleSubmit}
        orderInvoiceUUID={orderInvoiceUUID}
        submitLabel={i18n.t('done')}
      />
    </PageContainer>
  );
};
